import { Img } from "@/components/site/Img";
import SiteLink from "@/components/site/SiteLink";

const groups = [
  {
    title: "Fountains",
    links: [
      { label: "Available Pieces", href: "/available-now" },
      { label: "The Majestic", href: "/majestic" },
      { label: "Custom Builds", href: "/builds" },
      { label: "How It's Built", href: "/builds#how-its-built" },
    ],
  },
  {
    title: "Our Work",
    links: [
      { label: "Recent Work", href: "/gallery" },
      { label: "Featured Project", href: "/builds#featured-project" },
      { label: "Garden Tour", href: "/#walkthrough" },
    ],
  },
  {
    title: "The Shop",
    links: [
      { label: "Fountain Services", href: "/fountain-repair" },
      { label: "About", href: "/#about" },
      { label: "Contact", href: "/#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1F1E1C] text-[#D8D2C4] pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <nav
          data-testid="footer-nav"
          className="pt-8 sm:pt-10 border-t border-white/10 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-6 mb-8 sm:mb-10"
          aria-label="Footer navigation"
        >
          {groups.map((g) => (
            <div key={g.title}>
              <div className="hidden sm:block text-[10px] tracking-[0.32em] uppercase text-[#9E9A90] mb-4">{g.title}</div>
              <ul className="grid grid-cols-2 gap-x-6 gap-y-2 sm:block sm:space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.href}>
                    <SiteLink
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="inline-block py-1 sm:py-0 text-sm text-[#D8D2C4] hover:text-[#C8B387] transition-colors"
                    >
                      {l.label}
                    </SiteLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
        <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-xs text-[#9A958B]">
          <SiteLink href="/" data-testid="footer-link-home" className="flex items-center gap-3 hover:text-[#C8B387] transition-colors">
            <Img
              src="/images/gfys-logo.jpg"
              alt="Garden Fountains Yard Sculptures logo"
              data-testid="footer-logo-image"
              sizes="48px"
              loading="lazy"
              className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover border-2 border-[#C8B387]/50 flex-shrink-0"
            />
            <span className="font-serif text-sm text-[#F9F6F0]">
              Garden Fountains <span className="font-light">Yard Sculptures</span>
            </span>
          </SiteLink>
          <span className="flex flex-col md:items-end gap-1">
            <span>© {new Date().getFullYear()} Garden Fountains Yard Sculptures. All rights reserved.</span>
            <span data-testid="footer-credit" className="text-[11px] text-[#9E9A90]">
              Website created by{" "}
              <a
                href="https://andlorsolutions.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#C8B387] underline underline-offset-2 transition-colors"
              >
                Andlor Solutions
              </a>
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
}
